import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {PreloaderComponent} from './components/layouts/preloader/preloader.component';
import {NavbarComponent} from './components/layouts/navbar/navbar.component';
import {FooterComponent} from './components/layouts/footer/footer.component';
import {SubscribeComponent} from './components/layouts/subscribe/subscribe.component';
import {HomeOneComponent} from './components/pages/home-one/home-one.component';
import {AboutComponent} from './components/pages/about/about.component';
import {ServicesComponent} from './components/pages/services/services.component';
import {PricingComponent} from './components/pages/pricing/pricing.component';
import {ContactComponent} from './components/pages/contact/contact.component';
import {ServicesDetailsComponent} from './components/pages/services-details/services-details.component';
import {ProjectsComponent} from './components/pages/projects/projects.component';
import {ProjectsDetailsComponent} from './components/pages/projects-details/projects-details.component';
import {ErrorComponent} from './components/pages/error/error.component';
import {
    OurDataServiceComponent
} from './components/pages/services/Components/our-data-service/our-data-service.component';
import {
    OurWorkingProcessComponent
} from './components/pages/services/Components/our-working-process/our-working-process.component';
import {FeedbackComponent} from './components/pages/Shared/feedback/feedback.component';
import {
    OurDataProjectComponent
} from './components/pages/projects/Components/our-data-project/our-data-project.component';
import {
    OurProcessProjectsComponent
} from './components/pages/projects/Components/our-process-projects/our-process-projects.component';
import {LoginComponent} from './components/pages/Account/Components/login/login.component';
import {RegisterComponent} from './components/pages/Account/Components/register/register.component';
import {
    PrintErrorValidationComponent
} from "./components/pages/Shared/print-error-validation/print-error-validation.component";
import {HttpClientModule} from '@angular/common/http';
import {FormsModule} from '@angular/forms';
import {BrowserAnimationsModule, provideAnimations} from "@angular/platform-browser/animations";
import {provideToastr, ToastrModule} from 'ngx-toastr';
import {ShowPowerBiComponent} from './components/pages/show-power-bi/show-power-bi.component';
import {ShowAllPowerBiComponent} from './components/pages/show-all-power-bi/show-all-power-bi.component';
import {CategoryDetailsComponent} from './components/pages/category-details/category-details.component';
import { BlogDetailComponent } from './components/pages/blog-detail/blog-detail.component';
import { CountingComponent } from './components/pages/counting/counting.component';

@NgModule({
    declarations: [
        AppComponent,
        PreloaderComponent,
        NavbarComponent,
        FooterComponent,
        SubscribeComponent,
        HomeOneComponent,
        AboutComponent,
        ServicesComponent,
        PricingComponent,
        ContactComponent,
        ServicesDetailsComponent,
        ProjectsComponent,
        ProjectsDetailsComponent,
        ErrorComponent,
        OurDataServiceComponent,
        OurWorkingProcessComponent,
        FeedbackComponent,
        OurDataProjectComponent,
        OurProcessProjectsComponent,
        LoginComponent,
        RegisterComponent,
        PrintErrorValidationComponent,
        ShowPowerBiComponent,
        ShowAllPowerBiComponent,
        CategoryDetailsComponent,
        BlogDetailComponent,
        CountingComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        FormsModule,
        BrowserAnimationsModule,
        ToastrModule.forRoot(),

    ],
    providers: [
         provideAnimations(), // required animations providers
         provideToastr(), // Toastr providers
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}
